<template>
  <v-container class="top-spacer" style="padding: 0">
    <div class="component-title">Alertas</div>
    <v-row>
      <v-col cols="12">
        <div v-if="items.length > 0">
          <stack
            :column-min-width="250"
            :gutter-width="15"
            :gutter-height="15"
            style="height: 90vh"
          >
            <stack-item
              v-for="(alert, alertId) in items"
              :key="'alert-' + alertId"
              style="transition: transform 300ms"
            >
              <v-card style="padding-bottom: 4px !important">
                <v-row>
                  <v-col class="alert-header">{{ alert.date }}</v-col>
                </v-row>
                <div
                  v-for="(message, messageId) in alert.messages"
                  :key="'message-' + messageId"
                >
                  <v-row>
                    <v-col
                      v-html="message.text"
                      class="message-text"
                      :style="
                        message.read
                          ? 'text-decoration: line-through; color: #BCC5CC !important;'
                          : 'color: #6D818F !important;'
                      "
                    >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="message-time">{{ message.time }} </v-col>
                    <v-col class="message-action">
                      <v-btn icon @click="markAsRead(alert.id, message)">
                        <v-icon small :color="message.read ? 'primary' : 'grey'"
                          >mdi-check-circle-outline</v-icon
                        >
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-divider
                    v-if="messageId != alert.messages.length - 1"
                  ></v-divider>
                </div>
              </v-card>
            </stack-item>
          </stack>
        </div>
        <v-card v-else class="empty-state">
          Não existem alertas de momento
        </v-card>
      </v-col>
    </v-row>
    <!-- PAGINATION -->
    <v-row class="pagination">
      <v-col>
        <v-pagination
          v-model="page"
          :length="Math.ceil(this.items.length / 8)"
          :total-visible="3"
          color="#D8E0E6"
          style="float: left"
        ></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>


<style scoped>
.empty-state {
  width: 285px;
  height: 135px;
  text-align: center;
  vertical-align: middle;
  line-height: 135px !important;
  font-family: Gilroy-SemiBold;
  font-size: 12px;
  color: #9aabb8;
}
.line-through {
  text-decoration: line-through;
  color: #bcc5cc;
}
.alert-header {
  background-color: #d8e0e6;
  padding: 12px 12px 12px 16px;
  margin: 0 12px;
  border-radius: 6px 6px 0 0;
  font-family: Gilroy-Bold;
  font-size: 11px;
  line-height: 14px;
  color: #9aabb8;
}
.v-list-item {
  font-family: Gilroy-SemiBold;
  font-size: 12px;
  line-height: 16px;
  color: #6d818f !important;
  padding: 0 8px !important;
}
.message-text {
  font-family: Gilroy-SemiBold;
  font-size: 12px;
  line-height: 16px;
  color: #6d818f !important;
  padding: 16px 28px 8px 28px;
}
.message-time {
  font-family: Gilroy-Bold;
  font-size: 11px;
  line-height: 14px;
  color: #bcc5cc;
  padding-left: 28px;
}
.message-action {
  position: relative;
}
.message-action .v-btn {
  position: absolute;
  top: 0;
  right: 16px;
}
.v-card .v-list {
  padding-bottom: 0 !important;
}
.v-card >>> .v-list-item__subtitle {
  font-family: Gilroy-Bold;
  font-size: 11px;
  line-height: 14px;
  color: #bcc5cc;
}
.v-card >>> .v-list-item__action {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
@media only screen and (max-width: 1024px) {
}
@media only screen and (max-width: 768px) {
}
@media only screen and (max-width: 480px) {
}
</style>

<script>
import { Stack, StackItem } from "vue-stack-grid";

import ApiService from "@/services/api.service";

export default {
  name: "Alertas",
  components: {
    Stack,
    StackItem,
  },
  data: () => ({
    page: 1,
    showNewsDetails: false,
    selectedNews: {},
    alerts: [],
    totalPages: 0,
    loading: false,
  }),
  created() {
    this.getAlerts(0, 4);
  },
  methods: {
    getAlerts(page, size) {
      this.loading = true;
      ApiService.getAlerts(page, size).then(
        (response) => {
          const data = response.data;
          this.alerts = data.alerts;
          this.totalPages = data.totalPages;
          this.loading = false;
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    markAsRead(alertId, message) {
      if (!message.read) {
        this.loading = true;
        const hash = this.hashCode(message.text + message.time);
        ApiService.markAlertMessageAsRead(alertId, hash).then(
          (response) => {
            message.read = true;
            this.$store.commit("setUnread", this.$store.state.user.unread - 1);
          },
          (error) => {
            console.log(
              (error.response && error.response.data) ||
                error.message ||
                error.toString()
            );
          }
        );
      }
    },
    hashCode(s) {
      let h;
      for (let i = 0; i < s.length; i++) {
        h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
      }
      return h;
    },
  },
  computed: {
    items() {
      return this.alerts;
    },
    newsList() {
      return this.items.slice((this.page - 1) * 8, this.page * 8);
    },
  },
};
</script>
